export default __webpack_public_path__ + "static/media/info_icon2.b14fb295.svg";